import { BaseContextSetup, NoAdsDetector } from '@platforms/shared';
import { context, InstantConfigService } from '@wikia/ad-engine';
import { Injectable } from '@wikia/dependency-injection';
import { UcpDesktopStickyTopBoxAdExperiment } from './../../experiments/ucp-desktop-sticky-topboxad-experiment';

@Injectable()
export class UcpDesktopBaseContextSetup extends BaseContextSetup {
	constructor(
		private ucpDesktopStickyTopBoxAdExperiment: UcpDesktopStickyTopBoxAdExperiment,
		protected instantConfig: InstantConfigService,
		protected noAdsDetector: NoAdsDetector,
	) {
		super(instantConfig, noAdsDetector);
	}

	execute(): void {
		super.execute();

		context.set(
			'options.floatingMedrecDestroyable',
			this.instantConfig.get('icFloatingMedrecDestroyable'),
		);
		// sourced from front/scripts/shared/tracking/Tracker.js getUserIdForInternalTracking()
		context.set(
			'options.userId',
			(window.mw as any).config.get('wgTrackID') || (window.mw as any).config.get('wgUserId'),
		);
		context.set('options.disableStickyTopBoxAd', this.instantConfig.get('icDisableStickyTopBoxAd'));

		if (!context.get('options.disableStickyTopBoxAd')) {
			this.setupStickyTopBoxAdExperiment();
		}

		this.setupMidBoxAdIfEnabled();
	}

	private setupStickyTopBoxAdExperiment(): void {
		if (this.ucpDesktopStickyTopBoxAdExperiment.isTopBoxAdSticky()) {
			document.body.classList.add('has-sticky-top-box-ad');
		}
	}

	private setupMidBoxAdIfEnabled(): void {
		/* You can add the icbm__icReplaceOpenWebWithMidBoxAd=true query param to enable this feature.
		 * All other required parts will be added conditionally based on options.replaceOpenWebWithMidBoxAd.
		 * */
		const isReplaceOpenWebWithMidBoxAd = this.instantConfig.get(
			'icReplaceOpenWebWithMidBoxAd',
			false,
		);
		context.set('options.replaceOpenWebWithMidBoxAd', isReplaceOpenWebWithMidBoxAd);
		if (isReplaceOpenWebWithMidBoxAd) {
			/* See src/platforms/ucp-desktop/ad-context.ts for why this needs to be inserted here.
			 * We need to add it here, because the baseContext is initialized before any of the BaseServices are added to the pipeline.
			 *
			 * Check window.ads.adContext.bidders.a9.bidsRefreshing.slots and
			 * window.ads.adContext.bidders.a9.bidsRefreshing.slots for the updated slots.
			 *
			 * These context values are used in src/ad-bidders/a9/index.ts and src/ad-bidders/prebid/prebid-data-tracking.ts
			 *
			 * The adengine_debug=1 query param needs be used to see the updated slots in the console.
			 * */
			['a9', 'prebid'].forEach((bidder) => {
				const bidderRefreshSlots = context.get(
					`bidders.${bidder}.bidsRefreshing.slots`,
				) as Array<string>;
				if (bidderRefreshSlots) {
					bidderRefreshSlots.push('mid_boxad');
					context.set(`bidders.${bidder}.bidsRefreshing.slots`, bidderRefreshSlots);
				}
			});
		}
	}
}
